import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import Text from '../../../../atoms/Text';
import Icon from '../../../../atoms/Icon';

const cx = classNames.bind(styles);
interface FooterProps {
  deviceType: string;
  tncLink: string;
  isAppsFlag?: boolean;
  ctaInterceptor?: (action: { type: string; data: string }) => void;
}

const Footer = (props: FooterProps): JSX.Element => {
  const {
    deviceType = 'mobile',
    tncLink = '',
    isAppsFlag = false,
    ctaInterceptor = () => {}
  } = props;
  const tncClickHandler = (): void => {
    if (deviceType === 'mobile' && isAppsFlag === true) {
      ctaInterceptor({ type: 'GAMEZONE_TNC', data: tncLink });
    } else {
      window.location.href = tncLink;
    }
  };
  const backClickHandler = (): void => {
    window.location.href = '/';
  };

  return (
    <div className={cx('container', deviceType === 'desktop' && 'desktop-container')}>
      {deviceType === 'desktop' && (
        <div
          className={cx('actionButton', deviceType === 'desktop' && 'desktop-actionButton')}
          onClick={backClickHandler}
          onKeyDown={backClickHandler}
          role="button"
          tabIndex={0}
        >
          <Icon
            icon="icon-Chevron-Left"
            styles={{ fontSize: '1.4rem', color: '#202020', fontWeight: 'bold' }}
          />
          <Text variant="T3" weight="bold" color="Black">
            Back to www.ajio.com
          </Text>
        </div>
      )}
      <div
        className={cx('actionButton', deviceType === 'desktop' && 'desktop-actionButton')}
        onClick={tncClickHandler}
        onKeyDown={tncClickHandler}
        role="button"
        tabIndex={0}
      >
        <Text variant="T3" weight="bold" color="Black">
          Terms & Conditions
        </Text>
        <Icon
          icon="icon-Chevron-Right"
          styles={{ fontSize: '1.4rem', color: '#202020', fontWeight: 'bold' }}
          ariaLabel="expand"
        />
      </div>
    </div>
  );
};

Footer.defaultProps = {
  isAppsFlag: false,
  ctaInterceptor: () => {}
};

export default Footer;
